import React from 'react';
import CourseDescriptionStyle from './style';

export default function CourseDescriptionV2({bgImage, title, texts, addonStyle = {}, mt}) {
	let style = CourseDescriptionStyle();

	return (
		<div
			style={{
				...style.outerStyle(bgImage, mt),
				...addonStyle,
			}}
		>
			<div style={style.contentContainer()}>
				<h2 style={style.title()}>{title}</h2>
				{texts.map((text, i) => {
					return (
						<p style={style.genericText()} key={i}>
							{text}
						</p>
					);
				})}
			</div>
		</div>
	);
}
